const CoursesPop = ({ skill }) => {
    const skills = skill.skill.split(',')
    return (
        <div className="modal_body">
            <div className="attached_courses">
                <h2>attached skills <span className="mt_2">{skill.name?.toLowerCase()}</span></h2>
                {
                    skills?.map(ski => (
                        <p>{ski}<span className="mt_2"></span></p>
                    ))
                }
            </div>
        </div>
    )
};

export default CoursesPop;